var en_US = {};
en_US.strings = {
  addMore: 'Add more',
  addMoreFiles: 'Add more files',
  addingMoreFiles: 'Adding files',
  allowAccessDescription: 'In order to take pictures or record video with your camera, please allow camera access for this site.',
  allowAccessTitle: 'Allow camera access',
  authenticateWith: 'Go to %{pluginName}',
  authenticateWithTitle: 'Go to %{pluginName} to select files',
  back: 'Back',
  browse: 'browse',
  cancel: 'Cancel',
  cancelUpload: 'Cancel upload',
  chooseFiles: 'Choose files',
  closeModal: 'Close window',
  companionAuthError: 'Authentication required',
  companionError: 'Failed to connect',
  companionUnauthorizeHint: 'To revoke access to your %{provider} account, go to %{url}',
  complete: 'Completed',
  connectedToInternet: 'Connected to the network',
  copyLink: 'Copy link',
  copyLinkToClipboardFallback: 'Copy the link below',
  copyLinkToClipboardSuccess: 'Link copied to clipboard',
  creatingAssembly: 'Preparing files...',
  creatingAssemblyFailed: 'Transloadit: Failed to create Assembly',
  dashboardTitle: 'Upload files',
  dashboardWindowTitle: 'File upload window (Press escape to close)',
  dataUploadedOfTotal: '%{complete} of %{total}',
  done: 'Done',
  dropHereOr: 'Drop files or %{browse}',
  dropHint: 'Drop files you want to upload',
  dropPaste: 'Drop files, paste or %{browse}',
  dropPasteFiles: 'Drop files here, paste or %{browse}',
  dropPasteImport: 'Drop files, paste, %{browse} or import',
  edit: 'Edit',
  editFile: 'Edit file',
  editing: 'Editing %{file}',
  emptyFolderAdded: 'No files added from empty folder',
  encoding: 'Encoding...',
  enterCorrectUrl: 'Invalid URL: Make sure you provide a direct link to the file',
  enterUrlToImport: 'Enter URL to import file',
  exceedsSize: 'This file exceeds the allowed size',
  failedToFetch: 'Companion failed to fetch this URL, please make sure it’s correct',
  failedToUpload: 'Failed to upload file %{file}',
  fileSource: 'Source: %{name}',
  filesUploadedOfTotal: {
    '0': '%{complete} of %{smart_count} files uploaded',
    '1': '%{complete} of %{smart_count} files uploaded',
    '2': '%{complete} of %{smart_count} files uploaded'
  },
  filter: 'Filter',
  finishEditingFile: 'Finish editing file',
  folderAdded: {
    '0': '%{smart_count} file added from %{folder}',
    '1': '%{smart_count} files added from %{folder}',
    '2': '%{smart_count} files added from %{folder}'
  },
  generatingThumbnails: 'Generating thumbnails...',
  import: 'Import',
  importFrom: 'Import from %{name}',
  link: 'Link',
  loading: 'Loading...',
  logOut: 'Log out',
  myDevice: 'My device',
  noFilesFound: 'No files or folders found',
  noInternetConnection: 'No Internet connection',
  openFolderNamed: 'Open folder %{name}',
  pause: 'Pause',
  pauseUpload: 'Pause upload',
  paused: 'Paused',
  poweredBy: 'Powered by',
  preparingUpload: 'Preparing...',
  processingXFiles: {
    '0': 'Processing %{smart_count} file',
    '1': 'Processing %{smart_count} files',
    '2': 'Processing %{smart_count} files'
  },
  removeFile: 'Remove file',
  resetFilter: 'Reset filter',
  resume: 'Resume',
  resumeUpload: 'Resume upload',
  retry: 'Retry',
  retryUpload: 'Retry upload',
  saveChanges: 'Save changes',
  selectAllFilesFromFolderNamed: 'Select all files from folder %{name}',
  selectFileNamed: 'Select file %{name}',
  selectX: {
    '0': 'Select %{smart_count}',
    '1': 'Select %{smart_count}',
    '2': 'Select %{smart_count}'
  },
  smile: 'Smile!',
  startRecording: 'Start recording',
  stopRecording: 'Stop recording',
  takePicture: 'Take a picture',
  timedOut: 'Upload is taking too long, aborting.',
  unselectAllFilesFromFolderNamed: 'Unselect all files from folder %{name}',
  unselectFileNamed: 'Unselect file %{name}',
  upload: 'Upload',
  uploadComplete: 'Upload complete',
  uploadFailed: 'Upload failed',
  uploadPaused: 'Upload paused',
  uploadXFiles: {
    '0': 'Upload (%{smart_count})',
    '1': 'Upload (%{smart_count})',
    '2': 'Upload (%{smart_count})'
  },
  uploadXNewFiles: {
    '0': 'Upload (+%{smart_count})',
    '1': 'Upload (+%{smart_count})',
    '2': 'Upload (+%{smart_count})'
  },
  uploading: 'Uploading',
  uploadingXFiles: {
    '0': 'Uploading (%{smart_count})',
    '1': 'Uploading (%{smart_count})',
    '2': 'Uploading (%{smart_count})'
  },
  xFilesSelected: {
    '0': '%{smart_count} selected',
    '1': '%{smart_count} selected',
    '2': '%{smart_count} selected'
  },
  xMoreFilesAdded: {
    '0': '%{smart_count} file added',
    '1': '%{smart_count} files added',
    '2': '%{smart_count} files added'
  },
  xTimeLeft: '%{time} left',
  youCanOnlyUploadFileTypes: 'You can only upload: %{types}',
  youCanOnlyUploadX: {
    '0': 'You cannot upload more than: %{smart_count} files',
    '1': 'You cannot upload more than: %{smart_count} files',
    '2': 'You cannot upload more than: %{smart_count} files'
  },
  youHaveToAtLeastSelectX: {
    '0': 'You must select at least %{smart_count} file',
    '1': 'You must select at least %{smart_count} files',
    '2': 'You must select at least %{smart_count} files'
  }
};

en_US.pluralize = function (n) {
  if (n === 1) {
    return 0;
  }
  return 1;
};

if (typeof window !== 'undefined' && typeof window.Uppy !== 'undefined') {
  window.Uppy.locales.en_us = en_US;
}

module.exports = en_US;
